import useStyles from 'components/molcules/ProfitSummaryReport/useStyles'
import {useTranslation} from 'react-i18next'
import React from 'react'
import {Divider, Typography} from '@material-ui/core'
import {simpleSanitizeHTML} from 'helpers/analysisHelper'

interface HeadCell {
  id: string
  label: string
}

interface SummaryTableProps {
  items: HeadCell[]
  headerTitle: string
  descriptionTitle?: string
}

export default function SummaryTable({
  items,
  headerTitle,
  descriptionTitle,
}: SummaryTableProps) {
  const classes = useStyles()
  const {t} = useTranslation()

  return (
    <div>
      <Typography className={classes.padding} />
      <div className={classes.Table}>
        <div className='TableHeader'>
          <div className='title'>{headerTitle}</div>
          <div className='content'>{descriptionTitle || t('IDescription')}</div>
        </div>
        {items.map((item) => (
          <div key={item.id}>
            <div className='TableCell'>
              <div className='title'>{t(item.id)}</div>
              <div
                className='content'
                // @ts-ignore
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: simpleSanitizeHTML(item.label),
                }}
              />
            </div>
            <Divider />
          </div>
        ))}
      </div>
    </div>
  )
}
